import {InjectionToken} from '@angular/core';

// The benefit of using the Angular DI to get the window object, that we can easily change these into mocks in our tests
export const WINDOW = new InjectionToken<Window>('Global window object', {
  factory: (): Window => window
});
